const ConfigDataType = Object.freeze({
  Member: 1, ///Additional Member
  Team: 2,
  All: 3,
  NonNatca: 4,
  DefaultMember: 5,
});
export default ConfigDataType;
